import { Loading } from "@quark/design";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getExamDetail, startExam } from "../../../api";
import useDocumentTitle from "../../../hooks/use-document-title";

const ExamLogRedirect = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { examId } = params;
  const [loading, setLoading] = useState(false);
  useDocumentTitle(`二级题库刷题/${examId}`);
  useEffect(() => {
    const id = Number(examId);
    setLoading(true);
    getExamDetail(id)
      .then((detail) => {
        if (!detail.log) {
          return startExam(id).then((log) => {
            navigate(`/exam/${id}/${log.id}?continue=true`);
          });
        }
        navigate(`/exam/${id}/${detail.log.id}?continue=true`);
      })
      .catch(() => {
        alert("获取试题信息失败！");
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  if (loading) return <Loading />;

  return null;
};

export default ExamLogRedirect;
